import LicitacionesList from '../../components/LicitacionesList/LicitacionesList';
import { Filters } from '../../components/Filters/Filters';
import EmptyState from '../../components/EmptyState/EmptyState';
import { useComprasAgilesStore } from '../../store/comprasAgilesStore';
import { Speed } from '@mui/icons-material';

const ComprasAgiles = () => {
  const { comprasAgiles, page, limit, total, fetchComprasAgiles } = useComprasAgilesStore();

  const handlePageChange = (newPage: number, newLimit: number) => {
    fetchComprasAgiles({ silent: true, page: newPage, limit: newLimit });
  };

  if (comprasAgiles.length === 0 && total === 0) {
    return (
      <div>
        <Filters 
          onRefresh={() => fetchComprasAgiles({ page: 1, limit: 20 })}
          refreshTooltip="Actualizar compras ágiles"
          entityType="compras-agiles"
        />
        <EmptyState 
          title="No hay compras ágiles para mostrar"
          subtitle="No se encontraron compras ágiles disponibles en este momento. Los datos se actualizan automáticamente."
          icon={
            <Speed
              sx={{
                fontSize: 32,
                color: '#9E9E9E'
              }}
            />
          }
        />
      </div>
    );
  }

  return (
    <div>
      <Filters 
        onRefresh={() => fetchComprasAgiles({ page: 1, limit: 20 })}
        refreshTooltip="Actualizar compras ágiles"
        entityType="compras-agiles"
      />
      <LicitacionesList 
        data={comprasAgiles} 
        emptyMessage="No se encontraron compras ágiles"
        detailBasePath="/compras-agiles"
        entityType="compras-agiles"
        page={page}
        limit={limit}
        total={total}
        onPageChange={handlePageChange}
        onRefresh={() => fetchComprasAgiles({ silent: true, page, limit })}
      />
    </div>
  );
};

export default ComprasAgiles; 